import { SPORT_IDS } from "../../domain/sport/sportTypes";
import { TENNIS_MATCH_FORMAT } from "./config/matchFormat";
import { createTennisMatchEngine } from "./engine/createTennisMatchEngine";
import TennisCourt from "./ui/TennisCourt";
import TennisRefereeExtras from "./ui/TennisRefereeExtras";
import { createTennisStatisticsProvider } from "./stats/createStatisticsProvider";

function createMatchConfiguration() {
  return {
    getCatalog: () => TENNIS_MATCH_FORMAT,
    getDefaultCatalog: () => TENNIS_MATCH_FORMAT,
    getScoringSystem: () => "itf",
  };
}

function createMatchEngine() {
  return createTennisMatchEngine();
}

function createCourtRenderer() {
  return TennisCourt;
}

function createStatisticsProvider() {
  return createTennisStatisticsProvider();
}

function createRefereeExtras() {
  return TennisRefereeExtras;
}

export const tennisSportModule = {
  id: SPORT_IDS.TENNIS,
  displayName: "Tennis",
  icon: "racket",
  emoji: "🎾",
  selectionTagline: "Game · set · Singles · Doubles",
  isPlayable: true,
  supportsTournament: () => false,
  supportsRankings: () => false,
  supportsAchievements: () => false,
  createMatchConfiguration,
  createMatchEngine,
  createCourtRenderer,
  createStatisticsProvider,
  /** @deprecated prefer createStatisticsProvider */
  createStatsProvider: createStatisticsProvider,
  createRefereeExtras,
};
